import { useEffect, useState } from "react";
import { Translate, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";
import { LANGUAGES, getLanguage, setLanguage, onLanguageChange } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const LanguagePicker = ({ persist = true, className = "" }) => {
  const [lang, setLang] = useState(getLanguage());
  const { setUser } = useAuth() || {};
  useEffect(() => onLanguageChange(setLang), []);

  const choose = async (code) => {
    await setLanguage(code);
    if (persist) {
      try {
        await api.put("/auth/me/language", { language: code });
        setUser?.((u) => (u ? { ...u, language: code } : u));
      } catch { toast.error("Couldn't save your language preference"); }
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={`p-2 text-muted-foreground hover:text-foreground transition-colors duration-150 flex items-center gap-1 ${className}`}
          title="Language" data-testid="language-picker">
          <Translate size={20} />
          <span className="text-[11px] font-bold uppercase" data-no-translate>{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-sm" data-no-translate>
        {LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => choose(l.code)} data-testid={`language-option-${l.code}`} className="gap-2">
            <Check size={14} className={l.code === lang ? "opacity-100" : "opacity-0"} />{l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
